import { getRiskBandStyle } from '../../../utils/bands';

export type BoardReportRiskLevel = { level: string; color: string; icon: string };

/**
 * The board report's overall risk badge: the CRS band, or "Not measured" when there is no CRS.
 * No stand-in from another measure — the CRS does not exist without a full Big 6 (Pat, 2026-10-19).
 */
export function boardReportRiskLevel(crsScore: number | null | undefined): BoardReportRiskLevel {
  if (crsScore === null || crsScore === undefined) {
    return { level: 'Not measured', color: '#8892b0', icon: '—' };
  }
  const style = getRiskBandStyle(crsScore);
  return { level: style.label, color: style.text, icon: style.icon };
}
